import { render, staticRenderFns } from "./ShopFloorActivityProduct.vue?vue&type=template&id=2b8b822b&scoped=true"
import script from "./ShopFloorActivityProduct.vue?vue&type=script&lang=js"
export * from "./ShopFloorActivityProduct.vue?vue&type=script&lang=js"
import style0 from "./ShopFloorActivityProduct.vue?vue&type=style&index=0&id=2b8b822b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b822b",
  null
  
)

export default component.exports